import * as React from "react"
const FireHydrant = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    className="icon"
    transform="rotate(-45)"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="#A93439"
      d="M568.8 82.6c0-10.7-8.8-19.5-19.5-19.5h-75.2c-10.7 0-19.5 8.8-19.5 19.5v42.9c0 10.7 8.8 19.5 19.5 19.5h75.2c10.7 0 19.5-8.8 19.5-19.5V82.6z"
    />
    <path
      fill="#FF5959"
      d="M286.1 569c0-10.7-8.8-19.5-19.5-19.5H244c-10.7 0-19.5 8.8-19.5 19.5v55.7c0 10.7 8.8 19.5 19.5 19.5h22.7c10.7 0 19.5-8.8 19.5-19.5l-.1-55.7z"
    />
    <path
      fill="#A93439"
      d="M332.6 528.4c0-12.8-10.5-23.3-23.3-23.3h-20.9c-12.8 0-23.3 10.5-23.3 23.3v136.9c0 12.8 10.5 23.3 23.3 23.3h20.9c12.8 0 23.3-10.5 23.3-23.3V528.4z"
    />
    <path
      fill="#FF5959"
      d="M737.2 569c0-10.7 8.8-19.5 19.5-19.5h22.7c10.7 0 19.5 8.8 19.5 19.5v55.7c0 10.7-8.8 19.5-19.5 19.5h-22.7c-10.7 0-19.5-8.8-19.5-19.5V569z"
    />
    <path
      fill="#A93439"
      d="M690.8 528.4c0-12.8 10.5-23.3 23.3-23.3H735c12.8 0 23.3 10.5 23.3 23.3v136.9c0 12.8-10.5 23.3-23.3 23.3h-21c-12.8 0-23.3-10.5-23.3-23.3V528.4z"
    />
    <path
      fill="#FF5959"
      d="M761.3 309.1c-8.1 0-14.6-6.6-14.6-14.6V265c0-8.1 6.6-14.6 14.6-14.6 8.1 0 14.6 6.6 14.6 14.6v29.5c.1 8-6.5 14.6-14.6 14.6zm-499.2 0c-8.1 0-14.6-6.6-14.6-14.6V265c0-8.1 6.6-14.6 14.6-14.6s14.6 6.6 14.6 14.6v29.5c0 8-6.6 14.6-14.6 14.6zm445-9.6c0-107.9-87.5-195.4-195.4-195.4s-195.4 87.5-195.4 195.4h390.8zm-399.3 67.8h407.8v507.2H307.8z"
    />
    <path d="M307.8 779.8h407.8v46.9H307.8zm335.3-354.4c-8.1 0-14.6-6.6-14.6-14.6v-29.5c0-8.1 6.6-14.6 14.6-14.6 8.1 0 14.6 6.6 14.6 14.6v29.5c0 8-6.5 14.6-14.6 14.6zm-131.4 0c-8.1 0-14.6-6.6-14.6-14.6v-29.5c0-8.1 6.6-14.6 14.6-14.6 8.1 0 14.6 6.6 14.6 14.6v29.5c0 8-6.5 14.6-14.6 14.6zm-144.2 0c-8.1 0-14.6-6.6-14.6-14.6v-29.5c0-8.1 6.6-14.6 14.6-14.6s14.6 6.6 14.6 14.6v29.5c0 8-6.5 14.6-14.6 14.6z" />
    <path d="M307.8 367.3h407.8v68.8H307.8z" />
    <path
      fill="#A93439"
      d="M807.8 315.4c0-19.2-15.7-34.9-34.9-34.9H250.4c-19.2 0-34.9 15.7-34.9 34.9V351c0 19.2 15.7 34.9 34.9 34.9h522.5c19.2 0 34.9-15.7 34.9-34.9v-35.6zM781.9 908v41.8c0 6.4-5.2 11.6-11.6 11.6H253.1c-6.4 0-11.6-5.2-11.6-11.6V908c0-23.6 19.2-42.8 42.8-42.8h454.9c23.6 0 42.7 19.2 42.7 42.8zM420 596.9a91.7 91.7 0 1 0 183.4 0 91.7 91.7 0 1 0-183.4 0Z"
    />
    <path
      fill="#FF5959"
      d="M464.4 596.9a47.3 47.3 0 1 0 94.6 0 47.3 47.3 0 1 0-94.6 0Z"
    />
    <path
      fill="#A93439"
      d="M738.9 786.4c0 7.5-6.1 13.7-13.7 13.7h-427c-7.5 0-13.7-6.1-13.7-13.7v-21c0-7.5 6.1-13.7 13.7-13.7h427c7.5 0 13.7 6.1 13.7 13.7v21z"
    />
    <path d="M511.7 246.4c-8.1 0-14.6-6.6-14.6-14.6v-77.4c0-8.1 6.6-14.6 14.6-14.6 8.1 0 14.6 6.6 14.6 14.6v77.4c0 8.1-6.5 14.6-14.6 14.6zm-103.5 0c-8.1 0-14.6-6.6-14.6-14.6v-39c0-8.1 6.6-14.6 14.6-14.6 8.1 0 14.6 6.6 14.6 14.6v39c.1 8.1-6.5 14.6-14.6 14.6zm207 0c-8.1 0-14.6-6.6-14.6-14.6v-39c0-8.1 6.6-14.6 14.6-14.6 8.1 0 14.6 6.6 14.6 14.6v39c0 8.1-6.6 14.6-14.6 14.6z" />
  </svg>
)
export default FireHydrant